import axios from "../javascript/custom-axios";

const RESOURCE_NAME  = `/v1/listings`;

export default {
  /**
   * Create listing
   * @param {{ Title: string, Description: string, Contact: string, Price: number, ImageFileIds: number[] }} body
   * @returns {Promise}
   */
  createListing(body) {
    return axios.post(`${RESOURCE_NAME}`, body);
  },

  /**
   * Get all listings
   * @param {Object} params
   * @returns {Promise}
   */
  getListings(params) {
    return axios.get(`${RESOURCE_NAME}`, { params });
  },

  /**
   * Get current user's listings
   * @param {Object} params
   * @returns {Promise}
   */
  getMyListings(params) {
    return axios.get(`${RESOURCE_NAME}/my`, { params });
  },

  /**
   * Update listing status
   * @param {{ Id: number, Status: number }} body
   * @returns {Promise}
   */
  updateStatus(body) {
    return axios.put(`${RESOURCE_NAME}/status`, body);
  },
};
